import { gql } from '@apollo/client';

// Mutation to update an existing segment
export const UPDATE_SEGMENT_MUTATION = gql`
  mutation UpdateSegment($segment_id: String!, $input: CreateSegmentInput!) {
    updateSegment(segment_id: $segment_id, input: $input)
  }
`;
